// Registers global button tap haptic at app startup — imported from main.tsx so it
// covers all pages, not just game components that happen to load useFeedback.
//
// Uses 'click' (not 'touchstart') so the iOS <input switch> trick fires inside a
// proper click user-gesture; touchstart alone doesn't reliably trigger the Taptic Engine.

import { playTapUp, resumeAudio } from './hooks/useSounds';

const canVibrate = typeof navigator !== 'undefined' && 'vibrate' in navigator;

const isIOS =
  typeof navigator !== 'undefined' &&
  (/iPhone|iPad|iPod/.test(navigator.userAgent) ||
    (navigator.userAgent.includes('Mac') && navigator.maxTouchPoints > 1));

// Resume AudioContext on any interaction so the first button press is never silent.
for (const event of ['touchstart', 'touchend', 'pointerdown', 'scroll', 'keydown'] as const) {
  document.addEventListener(event, resumeAudio, { once: true, passive: true, capture: true });
}

// Exported so useHaptics can read it and skip h.tap() if the global already fired.
export let lastGlobalHapticMs = 0;

document.addEventListener(
  'click',
  (e) => {
    const btn = (e.target as Element | null)?.closest('button');
    if (!btn || btn.disabled) return;
    lastGlobalHapticMs = Date.now();
    playTapUp();
    if (isIOS) {
      const input = document.createElement('input');
      input.type = 'checkbox';
      input.setAttribute('switch', '');
      input.style.cssText = 'position:fixed;top:-200px;left:-200px;opacity:0;pointer-events:none;';
      const label = document.createElement('label');
      const uid = `_h${Date.now()}${Math.random()}`;
      input.id = uid;
      label.htmlFor = uid;
      document.body.appendChild(input);
      document.body.appendChild(label);
      label.click();
      requestAnimationFrame(() => {
        input.remove();
        label.remove();
      });
    } else if (canVibrate) {
      try { navigator.vibrate(30); } catch { /* silently ignore */ }
    }
  },
);
